const MILISECONDS = 1000;
const ONE_DAY_SECONDS = 86400;

export const dateAddSeconds = (date, seconds) => new Date(date.valueOf() + (MILISECONDS * seconds));
export const dateDiffSeconds = (date, seconds) => dateAddSeconds(date, -seconds);
export const dateAddDays = (date, days) => dateAddSeconds(date, ONE_DAY_SECONDS * days);
export const dateDiffDays = (date, days) => dateDiffSeconds(date, ONE_DAY_SECONDS * days);

export const beginOfTomorrowGMT = (date) => dateAddDays(new Date(date.setUTCHours(0, 0, 0, 0)), 1);

export const endOfWeek = date => {
  const weekDay = (date.getDay() === 0) ? 7 : date.getDay();
  const newMonthDay = (date.getDate() - weekDay) + 7;
  return new Date(new Date(date.setDate(newMonthDay)).setHours(23, 59, 59, 0));
};

const padNumber = n => ((n < 10) ? `0${n}` : `${n}`);
export const formatDate = (
  date => `${padNumber(date.getDate())}/${padNumber(date.getMonth() + 1)}/${date.getFullYear()}`
);
